// extracted by mini-css-extract-plugin
export default {"flex":"tY","imgwrap":"uY","image":"vY","textinfo":"wY","producttitle":"xY","bolder":"yY","block":"zY","info":"AY","moredetails":"BY","whitebox":"CY","old_price":"EY","discount":"FY"};
    if(module.hot) {
      // 1737143663955
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  